import React from 'react';

const IcUpload = (props) => {

    return (
        <svg width="1em" height="1em" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fillRule="evenodd" clipRule="evenodd" d="M11.2929 4.29289L8.29289 7.29289C7.90237 7.68342 7.90237 8.31658 8.29289 8.70711C8.68342 9.09763 9.31658 9.09763 9.70711 8.70711L11 7.41421L11 15C11 15.5523 11.4477 16 12 16C12.5523 16 13 15.5523 13 15V7.41421L14.2929 8.70711C14.6834 9.09763 15.3166 9.09763 15.7071 8.70711C16.0976 8.31658 16.0976 7.68342 15.7071 7.29289L12.7071 4.29289C12.5196 4.10536 12.2652 4 12 4C11.7348 4 11.4804 4.10536 11.2929 4.29289ZM6 12C6 11.4477 5.55228 11 5 11C4.44772 11 4 11.4477 4 12V18C4 19.1046 4.89543 20 6 20H18C19.1046 20 20 19.1046 20 18V12C20 11.4477 19.5523 11 19 11C18.4477 11 18 11.4477 18 12V18H6V12Z" fill="currentColor"/>
        </svg>
    )
}

export default IcUpload;